<div class="row mb-3">
  <div class="col-6">
    <label class="secondary-details">{{ 'userManagement.userManagement' | translate }}</label>
    <div class="ps-2 search-bar-group">
      <input
        matInput
        class="pt-2 input-search"
        [(ngModel)]="searchTerm"
        (keyup)="filterBySearch(this.searchTerm)"
        placeholder="{{ 'userManagement.searchUser' | translate }}" />
    </div>
  </div>
  <div class="col-6 text-end">
    <mat-form-field>
      <mat-select
        placeholder="{{ 'userManagement.status' | translate }}"
        [(value)]="selected_roletype"
        (selectionChange)="onStatusChange($event.value)">
        <mat-option *ngFor="let role of property_type" [value]="role.value">
          {{ role.type }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="text-end mr-2">
  <button *ngIf="isUserCanRegister()" class="primary-btn" (click)="openRegisterDailog()">
    {{ 'userManagement.register' | translate }}
  </button>
</div>

<div class="custom-card">
  <div class="col-12 table-container">
    <table aria-describedby="usersList" mat-table matSort [dataSource]="dataSource" class="mt-1">
      <ng-container matColumnDef="userID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userManagement.userId' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.userID }}</td>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userManagement.firstName' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element?.firstName }}</td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userManagement.lastName' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element?.lastName }}</td>
      </ng-container>

      <ng-container matColumnDef="customerID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userManagement.customerId' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.customerID }}</td>
      </ng-container>

      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userManagement.country' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.country }}</td>
      </ng-container>

      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userManagement.roles' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.roles }}</td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'userManagement.status' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <p class="m-0" *ngIf="!element.locked_temp && element.active">{{ 'userManagement.active' | translate }}</p>
          <p class="m-0" *ngIf="!element.active">{{ 'userManagement.inactive' | translate }}</p>
          <p class="m-0" *ngIf="element.locked_temp">{{ 'userManagement.locked' | translate }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="Action">
        <th mat-header-cell *matHeaderCellDef>{{ 'global.action' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <i
            matTooltip="{{ 'userManagement.assignRole' | translate }}"
            (click)="openrolesDialog(element)"
            class="icon-mat bi bi-person-add"></i>
          <i
            matTooltip="{{ 'userManagement.activate' | translate }}"
            class="icon-mat bi bi-person-check"
            *ngIf="!element.active && isUserCanActivated(element)"
            (click)="openDialogActivate(element.userID)">
          </i>
          <i
            matTooltip="{{ 'userManagement.unlock' | translate }}"
            class="icon-mat bi bi-unlock"
            *ngIf="element.locked_temp && isUserCanUnlocked(element)"
            (click)="openDialogAction(element.userID, element.customerID, 'UnLock')">
          </i>

          <i
            matTooltip="{{ 'userManagement.inactivate' | translate }}"
            class="icon-mat bi bi-person-x"
            *ngIf="element.active && isUserCanInActivated(element)"
            (click)="openDialogAction(element.userID, element.customerID, 'Inactivate')">
          </i>
          <i
            class="icon-mat bi bi-trash"
            *ngIf="isUserCanDeleted(element)"
            (click)="openDialogAction(element.userID, element.customerID, 'Delete')">
          </i>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row justify-content-center" *matNoDataRow>
        {{ 'global.noDataAvailable' | translate }}
      </tr>
    </table>
    <mat-paginator
      [pageSize]="25"
      [pageSizeOptions]="[25, 50, 100]"
      showFirstLastButtons></mat-paginator>
  </div>
</div>
<ng-template #dialogassignrole>
  <div>
    <div>
      <p>{{ 'userManagement.assignRoles' | translate }}</p>
    </div>
    <div>
      <mat-form-field class="rolelist">
        <mat-select (selectionChange)="selectRole($event)" [(ngModel)]="roles" multiple>
          <mat-option *ngFor="let roles of Roles" [value]="roles">
            {{ roles }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button type="button" class="btn btn-danger" [disabled]="!isSelected" (click)="assignRole()">
        {{ 'global.submit' | translate }}
      </button>
      <button class="secondary-btn ml-2" (click)="closeDialog()">{{ 'global.cancel' | translate }}</button>
    </div>
  </div>
</ng-template>
